// Segments
export const FacebookUser = (medium, source) => {

    return {
        objectType: 'Seller',
        medium: medium,
        source: source
    }
};
